import type { TDraggedPanelSize, TPanelPlacement } from 'stores/detailsPanelStore/detailsPanelStore'

export const getDraggedSize = ({
  sizeDuringDrag,
  draggedPanelSize,
  placement,
  isWideScreen,
}: {
  sizeDuringDrag: number | null
  draggedPanelSize: TDraggedPanelSize | null
  placement: TPanelPlacement
  isWideScreen: boolean
}) => {
  if (sizeDuringDrag !== null) return sizeDuringDrag

  return isWideScreen && draggedPanelSize?.placement === placement ? draggedPanelSize.size : null
}
